// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation_root__1fq8Q","backButton":"Navigation_backButton__oz3MN","info":"Navigation_info__zOdhF","badge":"Navigation_badge__1Lpi8","paid":"Navigation_paid__13lkJ"};